import React, { useEffect, useState } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import { useDispatch } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setWhitepaperData } from "../../../../../Redux/slices/mngrSlice";
import MFieldImage from "Utils/Helpers/MFieldImage";
import { post_whitepaper } from "http/components/Whitepaper";

export default function AddWhitepapersData() {
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [controls, setControls] = useSetState({
    title: {
      label: "Title",
      type: "text",
      multiLine: false,
      placeholder: "Enter title",
      value: "",
      validation: false,
    },
    description: {
      label: "Description",
      type: "text",
      multiLine: true,
      placeholder: "Enter description",
      value: "",
      validation: false,
    },
  });

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setControls({ title: { value: "", validation: false } });
    setControls({ description: { value: "", validation: false } });
    setImage(null);
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onSelectImage = (selected) => {
    setImage(selected);
  };

  const onSubmit = async () => {
    const { title, tags, description } = controls;
    if (title.validation && description.validation && image) {
      dispatch(HandleLoading(true));
      let formData = new FormData();
      formData.append("title", title.value);
      formData.append("description", description.value);
      formData.append("image", image);
      const response = await post_whitepaper(formData);
      if (CheckApiStatus(response)) {
        onClear();
        dispatch(setWhitepaperData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={{ xs: 12 }}>
        <MFieldImage
          name={"Icon (transparent png)"}
          image={image}
          onChange={onSelectImage}
        />
      </Grid2>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid2 size={{ sm: 6, xs: 12 }} key={key + index}>
            {controls[key].type === "text" && (
              <Inputer
                id={key}
                setValue={setValue.bind(this)}
                value={controls[key].value}
                label={controls[key].label}
                placeholder={controls[key].placeholder}
                type={controls[key].type}
                multiLine={controls[key].multiLine}
              />
            )}
          </Grid2>
        );
      })}
      <Grid2 size={{ xs: 12 }}>
        <MButton label={"Save"} onClick={onSubmit} />
      </Grid2>
    </Grid2>
  );
}
